const Office365Icon = /*#__PURE__*/ [
  ["path", { d: "M4 18V6L14.5 2L20 4V20L14.5 22L4 18ZM4 18L14 18.5V6L8.5 7.5V15.5L4 18Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export { Office365Icon as default };
//# sourceMappingURL=Office365Icon.js.map
